import { render, staticRenderFns } from "./deletewaringmessage.vue?vue&type=template&id=49f46960&"
import script from "./deletewaringmessage.vue?vue&type=script&lang=ts&"
export * from "./deletewaringmessage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "deletewaringmessage.vue"
export default component.exports